import { gql } from '@apollo/client';

export const GET_ALL_PROJECTS = gql`
  query GetAllProjects {
    projects {
      name
      slug
      short_description
      year
      media {
        enable_mux_video
        mux_video {
          playback_id
        }
        desktop_media {
          alternativeText
          url
        }
        mobile_media {
          alternativeText
          url
        }
      }
    }
  }
`;

export const GET_PROJECT_BY_SLUG = gql`
  query GetProjectBySlug($slug: String!) {
    projects(filters: { slug: { eq: $slug } }) {
      name
      slug
      short_description
      year
      media {
        enable_mux_video
        mux_video {
          playback_id
        }
        desktop_media {
          alternativeText
          url
        }
        mobile_media {
          alternativeText
          url
        }
      }
    }
  }
`;
export const GET_ALL_JOURNALS = gql`
  query GetAllJournals {
    journals {
      name
      slug
      awards_text
      date
      description
      button {
        button_text
        button_url
        open_link_in_new_tab
      }
      createdAt
      updatedAt
      publishedAt
      documentId
      media {
        enable_mux_video
        mux_video {
          playback_id
        }
        desktop_media {
          alternativeText
          url
        }
        mobile_media {
          alternativeText
          url
        }
      }
    }
  }
`;
export const GET_BY_SLUG_JOURNALS = gql`
  query GetBySlugJournals($slug: String!) {
    journals(filters: { slug: { eq: $slug } }) {
      name
      slug
      awards_text
      date
      description
      button {
        button_text
        button_url
        open_link_in_new_tab
      }
      createdAt
      updatedAt
      publishedAt
      documentId
      media {
        enable_mux_video
        mux_video {
          playback_id
        }
        desktop_media {
          alternativeText
          url
        }
        mobile_media {
          alternativeText
          url
        }
      }
    }
  }
`;
export const GET_ALL_PAGES = gql`
  query GetAllPages {
    pages {
      slug
    }
  }
`;

export const GET_PAGE_BY_SLUG = gql`
  query GetPageBySlug($slug: String!) {
    pages(filters: { slug: { eq: $slug } }) {
      name
      slug
      short_description
      page_color
      template_type
      blocks {
        __typename
        ... on ComponentSectionsHomeHero {
          show_this_section_in_the_sidebar
          main_logo {
            alternativeText
            url
          }
          media {
            enable_mux_video
            mux_video {
              playback_id
            }
            desktop_media {
              alternativeText
              url
            }
            mobile_media {
              alternativeText
              url
            }
          }
          about_tbc {
            logo {
              alternativeText
              url
            }            
          }
          padding {
            desktop_top_padding
            desktop_bottom_padding
            mobile_top_padding
            mobile_bottom_padding
          }
        }

        ... on ComponentSectionsFeaturedProjects {
          projects {
            name
            slug
            short_description
            year
            media {
              enable_mux_video
              mux_video {
                playback_id
              }
              desktop_media {
                alternativeText
                url
              }
              mobile_media {
                alternativeText
                url
              }
            }
          }
          padding {
            desktop_top_padding
            desktop_bottom_padding
            mobile_top_padding
            mobile_bottom_padding
          }
        }

        ... on ComponentSectionsProcess {
          show_this_section_in_the_sidebar
          heading
          media {
            enable_mux_video
            mux_video {
              playback_id
            }
            desktop_media {
              url
              alternativeText
            }
            mobile_media {
              url
              alternativeText
            }
          }
          Process: content {
            text
          }
          about_the_process {
            explore_button_label
            link {
              button_text
              button_url
              open_link_in_new_tab
            }
            process_section {
              button_text
              button_url
              open_link_in_new_tab
            }
          }
          padding {
            desktop_top_padding
            desktop_bottom_padding
            mobile_top_padding
            mobile_bottom_padding
          }
        }

        ... on ComponentSectionsFeaturedNews {
          show_this_section_in_the_sidebar
          heading
          journals {
            name
            slug
            awards_text
            date
            description
            button {
              button_text
              button_url
              open_link_in_new_tab
            }
            createdAt
            updatedAt
            publishedAt
            documentId
            media {
              enable_mux_video
              mux_video {
                playback_id
              }
              desktop_media {
                alternativeText
                url
              }
              mobile_media {
                alternativeText
                url
              }
            }
          }
          padding {
            desktop_top_padding
            desktop_bottom_padding
            mobile_top_padding
            mobile_bottom_padding
          }
        }

        ... on ComponentSectionsFullWidthMedia {
          full_widht_media {
            enable_mux_video
            mux_video {
              playback_id
            }
            desktop_media {
              url
              alternativeText
            }
            mobile_media {
              url
              alternativeText
            }
          }
          enable_video_controls
          padding {
            desktop_top_padding
            desktop_bottom_padding
            mobile_top_padding
            mobile_bottom_padding
          }
        }

        ... on ComponentSectionsLogoWidthDescription {
          description
          logo {
            alternativeText
            url
          }
          padding {
            desktop_top_padding
            desktop_bottom_padding
            mobile_top_padding
            mobile_bottom_padding
          }
        }

        ... on ComponentSections2ColumnMedia {
          ColumnMedia: media {
            enable_mux_video
            mux_video {
              playback_id
            }
            desktop_media {
              alternativeText
              url
            }
            mobile_media {
              alternativeText
              url
            }
          }
          padding {
            desktop_top_padding
            desktop_bottom_padding
            mobile_top_padding
            mobile_bottom_padding
          }
        }

        ... on ComponentSections2ColumnTextBlock {
          show_this_section_in_the_sidebar
          heading
          content
          padding {
            desktop_top_padding
            desktop_bottom_padding
            mobile_top_padding
            mobile_bottom_padding
          }
        }

        ... on ComponentSectionsAanerdiaBox {
          nerdia_box {
            title
            designation
            description
            button {
              button_text
              button_url
              open_link_in_new_tab
            }
            media {
              enable_mux_video
              mux_video {
                playback_id
              }
              desktop_media {
                alternativeText
                url
              }
              mobile_media {
                alternativeText
                url
              }
            }
          }
          padding {
            desktop_top_padding
            desktop_bottom_padding
            mobile_top_padding
            mobile_bottom_padding
          }
        }

        ... on ComponentSectionsOurTeam {
          show_this_section_in_the_sidebar
          heading
          profile_btn_label
          team(pagination: { limit: -1 }) {
            name
            designation
            description
            media {
              enable_mux_video
              mux_video {
                playback_id
              }
              desktop_media {
                alternativeText
                url
              }
              mobile_media {
                alternativeText
                url
              }
            }
          }
          padding {
            desktop_top_padding
            desktop_bottom_padding
            mobile_top_padding
            mobile_bottom_padding
          }
        }

        ... on ComponentSectionsInlineTextBlock {
          show_this_section_in_the_sidebar
          heading
          content
          padding {
            desktop_top_padding
            desktop_bottom_padding
            mobile_top_padding
            mobile_bottom_padding
          }
        }

        ... on ComponentSections2ColumnMediaWithContent {
          reverse_layout
          content
          media {
            enable_mux_video
            mux_video {
              playback_id
            }
            desktop_media {
              alternativeText
              url
            }
            mobile_media {
              alternativeText
              url
            }
          }
          padding {
            desktop_top_padding
            desktop_bottom_padding
            mobile_top_padding
            mobile_bottom_padding
          }
        }

        ... on ComponentSectionsAwardsAndRecognition {
          show_this_section_in_the_sidebar
          heading
          view_btn_label
          awards_list {
            title
            year
            link
          }
          padding {
            desktop_top_padding
            desktop_bottom_padding
            mobile_top_padding
            mobile_bottom_padding
          }
        }

        ... on ComponentSectionsExploreOurProjects {
          show_this_section_in_the_sidebar
          heading
          projects {
            documentId
            name
            slug
            media {
              enable_mux_video
              mux_video {
                playback_id
              }
              desktop_media {
                alternativeText
                url
              }
              mobile_media {
                alternativeText
                url
              }
            }
          }
          padding {
            desktop_top_padding
            desktop_bottom_padding
            mobile_top_padding
            mobile_bottom_padding
          }
          button {
            button_text
            button_url
            open_link_in_new_tab
          }
        }

        ... on ComponentSectionsResources {
          show_this_section_in_the_sidebar
          heading
          resources {
            title
            file {
              alternativeText
              url
            }
          }
          padding {
            desktop_top_padding
            desktop_bottom_padding
            mobile_top_padding
            mobile_bottom_padding
          }
        }

        ... on ComponentSectionsFaQs {
          show_this_section_in_the_sidebar
          heading
          faqs {
            heading
            content
          }
          padding {
            desktop_top_padding
            desktop_bottom_padding
            mobile_top_padding
            mobile_bottom_padding
          }
        }

        ... on ComponentSectionsOurServices {
          show_this_section_in_the_sidebar
          services {
            heading
            content
          }
          padding {
            desktop_top_padding
            desktop_bottom_padding
            mobile_top_padding
            mobile_bottom_padding
          }
        }
      }
    }
  }
`;
// graphql/queries.js

export const JOURNALS_QUERY = gql`
  query Journals {
    journals {
      name
      slug
      awards_text
      date
      media {
        enable_mux_video
        mux_video {
          playback_id
        }
        desktop_media {
          alternativeText
          url
        }
        mobile_media {
          alternativeText
          url
        }
      }
      description
      button {
        button_text
        button_url
        open_link_in_new_tab
      }
    }
  }
`;

export const PROJECT_CATEGORIES_QUERY = gql`
  query ProjectCategories {
    projectCategories {
      name
      slug
      projects {
        name
        slug
        short_description
        year
      }
    }
  }
`;

export const PROJECTS_QUERY = gql`
    query Projects($limit: Int, $start: Int) {
    projects(sort: "rank", pagination: { limit: $limit, start: $start }) {
      name
      slug
      short_description
      year
      media {
        enable_mux_video
        mux_video {
          playback_id
        }
        desktop_media {
          alternativeText
          url
        }
        mobile_media {
          alternativeText
          url
        }
      }
      project_categories {
        name
        slug
      }
      description
      about_project {
        label
        value
      }
    }
  }
`;

export const PROJECTS_QUERY_SLUG = gql`
  query GetCurrentAndNextProject($slug: String!) {
    projects(filters: { slug: { eq: $slug } }) {
      name
      slug
      short_description
      year
      media {
        enable_mux_video
        mux_video {
          playback_id
        }
        desktop_media {
          alternativeText
          url
        }
        mobile_media {
          alternativeText
          url
        }
      }
      video {
        enable_video_controls
        mux_video {
          playback_id 
        }
      }
      project_categories {
        name
        slug
      }
      description
      about_project {
        label
        value
      }
      blocks {
        ... on ComponentSectionsFullWidthMedia {
          full_widht_media {
            enable_mux_video
            mux_video {
              playback_id
            }
            desktop_media {
              alternativeText
              url
            }
            mobile_media {
              alternativeText
              url
            }
          }
          enable_video_controls
          padding {
            desktop_top_padding
            desktop_bottom_padding
            mobile_top_padding
            mobile_bottom_padding
          }
        }
        ... on ComponentSections2ColumnMedia {
          ColumnMedia: media {
            enable_mux_video
            mux_video {
              playback_id
            }
            desktop_media {
              alternativeText
              url
            }
            mobile_media {
              alternativeText
              url
            }
          }
          padding {
            desktop_top_padding
            desktop_bottom_padding
            mobile_top_padding
            mobile_bottom_padding
          }
        }
        ... on ComponentSections2ColumnMediaWithContent {
          reverse_layout
          media {
            enable_mux_video
            mux_video {
              playback_id
            }
            desktop_media {
              alternativeText
              url
            }
            mobile_media {
              alternativeText
              url
            }
          }
          content
          padding {
            desktop_top_padding
            desktop_bottom_padding
            mobile_top_padding
            mobile_bottom_padding
          }
        }
      }
      related_projects {
        name
        slug
        media {
          enable_mux_video
          mux_video {
            playback_id
          }
          desktop_media {
            alternativeText
            url
          }
          mobile_media {
            alternativeText
            url
          }
        }
      }
    }
  }
`;

export const GLOBAL_QUERY = gql`
  query Global {
    global {
      site_name
      site_description
      site_logo {
        alternativeText
        url
      }
      site_favicon {
        alternativeText
        url
      }
      header {
        enquire_menu_label
        enquire_menu_link
        menu {
          name
          link
          image {
            alternativeText
            url
          }
        }
        left_side_text
        right_side_text
        site_details
      }
      footer {
        top_left_side_text
        menu {
          name
          link
        }
        terms_and_conditions_text
        terms_and_conditions_link
        site_by_text
        join_the_newsletter_text
        about_tbc {
          logo {
            alternativeText
            url
          }          
        }
      }
      newsletter_overlay_heading
    }
  }
`;

export const PAGES_QUERY = gql`
  query Pages {
    pages {
      name
      slug
      short_description
      page_color
      template_type
      blocks {
        ... on ComponentSectionsHomeHero {
          show_this_section_in_the_sidebar
          main_logo {
            alternativeText
            url
          }
          media {
            enable_mux_video
            mux_video {
              playback_id
            }
            desktop_media {
              alternativeText
              url
            }
            mobile_media {
              alternativeText
              url
            }
          }
          about_tbc {
            logo {
              alternativeText
              url
            }            
          }
          padding {
            desktop_top_padding
            desktop_bottom_padding
            mobile_top_padding
            mobile_bottom_padding
          }
        }

        ... on ComponentSectionsFeaturedProjects {
          projects {
            name
            slug
            short_description
            year
            media {
              enable_mux_video
              desktop_media {
                alternativeText
                url
              }
              mobile_media {
                alternativeText
                url
              }
              mux_video {
                playback_id
              }
            }
          }
          padding {
            desktop_top_padding
            desktop_bottom_padding
            mobile_top_padding
            mobile_bottom_padding
          }
        }

        ... on ComponentSectionsProcess {
          show_this_section_in_the_sidebar
          heading
          media {
            enable_mux_video
            mux_video {
              playback_id
            }
            desktop_media {
              url
              alternativeText
            }
            mobile_media {
              url
              alternativeText
            }
          }
          Process: content {
            text
          }
          about_the_process {
            explore_button_label
            link {
              button_text
              button_url
              open_link_in_new_tab
            }
            process_section {
              button_text
              button_url
              open_link_in_new_tab
            }
          }
          padding {
            desktop_top_padding
            desktop_bottom_padding
            mobile_top_padding
            mobile_bottom_padding
          }
        }

        ... on ComponentSectionsFeaturedNews {
          show_this_section_in_the_sidebar
          heading
          journals {
            name
            slug
            awards_text
            date
            media {
              enable_mux_video
              mux_video {
                playback_id
              }
              desktop_media {
                alternativeText
                url
              }
              mobile_media {
                alternativeText
                url
              }
            }
            description
            button {
              button_text
              button_url
              open_link_in_new_tab
            }
          }
          padding {
            desktop_top_padding
            desktop_bottom_padding
            mobile_top_padding
            mobile_bottom_padding
          }
        }

        ... on ComponentSectionsFullWidthMedia {
          full_widht_media {
            enable_mux_video
            mux_video {
              playback_id
            }
            desktop_media {
              url
              alternativeText
            }
            mobile_media {
              url
              alternativeText
            }
          }
          enable_video_controls
          padding {
            desktop_top_padding
            desktop_bottom_padding
            mobile_top_padding
            mobile_bottom_padding
          }
        }

        ... on ComponentSectionsLogoWidthDescription {
          description
          logo {
            alternativeText
            url
          }
          padding {
            desktop_top_padding
            desktop_bottom_padding
            mobile_top_padding
            mobile_bottom_padding
          }
        }

        ... on ComponentSections2ColumnMedia {
          ColumnMedia: media {
            enable_mux_video
            mux_video {
              playback_id
            }
            desktop_media {
              alternativeText
              url
            }
            mobile_media {
              alternativeText
              url
            }
          }
          padding {
            desktop_top_padding
            desktop_bottom_padding
            mobile_top_padding
            mobile_bottom_padding
          }
        }

        ... on ComponentSections2ColumnTextBlock {
          show_this_section_in_the_sidebar
          heading
          content
          padding {
            desktop_top_padding
            desktop_bottom_padding
            mobile_top_padding
            mobile_bottom_padding
          }
        }

        ... on ComponentSectionsAanerdiaBox {
          nerdia_box {
            title
            designation
            media {
              enable_mux_video
              mux_video {
                playback_id
              }
              desktop_media {
                alternativeText
                url
              }
              mobile_media {
                alternativeText
                url
              }
            }
            description
            button {
              button_text
              button_url
              open_link_in_new_tab
            }
          }
          padding {
            desktop_top_padding
            desktop_bottom_padding
            mobile_top_padding
            mobile_bottom_padding
          }
        }

        ... on ComponentSectionsOurTeam {
          show_this_section_in_the_sidebar
          heading
          profile_btn_label
          team(pagination: { limit: -1 }) {
            name
            designation
            description
            media {
              enable_mux_video
              mux_video {
                playback_id
              }
              desktop_media {
                alternativeText
                url
              }
              mobile_media {
                alternativeText
                url
              }
            }
          }
          padding {
            desktop_top_padding
            desktop_bottom_padding
            mobile_top_padding
            mobile_bottom_padding
          }
        }

        ... on ComponentSectionsInlineTextBlock {
          show_this_section_in_the_sidebar
          heading
          content
          padding {
            desktop_top_padding
            desktop_bottom_padding
            mobile_top_padding
            mobile_bottom_padding
          }
        }

        ... on ComponentSections2ColumnMediaWithContent {
          reverse_layout
          media {
            enable_mux_video
            mux_video {
              playback_id
            }
            desktop_media {
              alternativeText
              url
            }
            mobile_media {
              alternativeText
              url
            }
          }
          content
          padding {
            desktop_top_padding
            desktop_bottom_padding
            mobile_top_padding
            mobile_bottom_padding
          }
        }

        ... on ComponentSectionsAwardsAndRecognition {
          show_this_section_in_the_sidebar
          heading
          view_btn_label
          awards_list {
            title
            year
            link
          }
          padding {
            desktop_top_padding
            desktop_bottom_padding
            mobile_top_padding
            mobile_bottom_padding
          }
        }

        ... on ComponentSectionsExploreOurProjects {
          show_this_section_in_the_sidebar
          heading
          projects {
            name
            slug
            media {
              enable_mux_video
              mux_video {
                playback_id
              }
              desktop_media {
                alternativeText
                url
              }
              mobile_media {
                alternativeText
                url
              }
            }
          }
          padding {
            desktop_top_padding
            desktop_bottom_padding
            mobile_top_padding
            mobile_bottom_padding
          }
          button {
            button_text
            button_url
            open_link_in_new_tab
          }

        }

        ... on ComponentSectionsResources {
          show_this_section_in_the_sidebar
          heading
          resources {
            title
            file {
              alternativeText
              url
            }
          }
          padding {
            desktop_top_padding
            desktop_bottom_padding
            mobile_top_padding
            mobile_bottom_padding
          }
        }

        ... on ComponentSectionsFaQs {
          show_this_section_in_the_sidebar
          heading
          faqs {
            heading
            content
          }
          padding {
            desktop_top_padding
            desktop_bottom_padding
            mobile_top_padding
            mobile_bottom_padding
          }
        }

         ... on ComponentSectionsOurServices {
          show_this_section_in_the_sidebar
          services {
            heading
            content
          }
          padding {
            desktop_top_padding
            desktop_bottom_padding
            mobile_top_padding
            mobile_bottom_padding
          }
        }
      }
    }
  }
`;
export const PROJECTS_QUERY_BY_ID = gql`
  query ProjectById($id: ID!) {
    project(id: $id) {
      id
      name
      slug
      short_description
      year
      media {
        enable_mux_video
        mux_video {
          playback_id
        }
        desktop_media {
          alternativeText
          url
        }
        mobile_media {
          alternativeText
          url
        }
      }
      video {
        enable_video_controls
        mux_video {
          playback_id
        }
      }
      project_categories {
        name
        slug
      }
      description
      about_project {
        label
        value
      }
      blocks {
        ... on ComponentSectionsFullWidthMedia {
          full_widht_media {
            enable_mux_video
            mux_video {
              playback_id
            }
            desktop_media {
              alternativeText
              url
            }
            mobile_media {
              alternativeText
              url
            }
          }
          enable_video_controls
          padding {
            desktop_top_padding
            desktop_bottom_padding
            mobile_top_padding
            mobile_bottom_padding
          }
        }
        ... on ComponentSections2ColumnMedia {
          ColumnMedia: media {
            enable_mux_video
            mux_video {
              playback_id
            }
            desktop_media {
              alternativeText
              url
            }
            mobile_media {
              alternativeText
              url
            }
          }
          padding {
            desktop_top_padding
            desktop_bottom_padding
            mobile_top_padding
            mobile_bottom_padding
          }
        }
        ... on ComponentSections2ColumnMediaWithContent {
          reverse_layout
          media {
            enable_mux_video
            mux_video {
              playback_id
            }
            desktop_media {
              alternativeText
              url
            }
            mobile_media {
              alternativeText
              url
            }
          }
          content
          padding {
            desktop_top_padding
            desktop_bottom_padding
            mobile_top_padding
            mobile_bottom_padding
          }
        }
      }
    }
  }
`;

export const NEXT_PROJECT_QUERY = gql`
  query GetNextProject {
    projects(sort: "rank") {
      name
      slug
      media {
        enable_mux_video
        mux_video {
          playback_id
        }
        desktop_media {
          alternativeText
          url
        }
        mobile_media {
          alternativeText
          url
        }
      }
    }
  }
`;